import { Link } from 'react-router-dom';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export default function NotFound() {
  useDocumentMeta({
    title: 'Page not found',
    description: "The page you were looking for doesn't exist or may have moved.",
    robots: 'noindex',
  });
  return (
    <section
      aria-labelledby="notfound-heading"
      className="mx-auto flex min-h-[70vh] max-w-3xl flex-col items-start justify-center px-6 py-20 lg:px-16"
    >
      <p className="mb-4 text-sm font-semibold uppercase tracking-wider text-text-gray">
        404
      </p>
      <h1
        id="notfound-heading"
        className="mb-4 font-heading text-4xl font-bold text-text-primary md:text-5xl"
      >
        Page not found
      </h1>
      <p className="mb-10 max-w-xl text-base leading-relaxed text-text-gray">
        The page you were looking for doesn&apos;t exist or may have moved. Try heading back to the
        home page, or browse the latest insights.
      </p>
      <div className="flex flex-wrap gap-3">
        <Link
          to="/"
          className="rounded-lg bg-text-primary px-5 py-2.5 text-sm font-semibold text-surface-elevated transition-colors hover:bg-text-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-blue focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--color-bg)]"
        >
          Back to home
        </Link>
        <Link
          to="/insights"
          className="rounded-lg border border-surface-border-gray bg-surface-elevated px-5 py-2.5 text-sm font-semibold text-text-primary transition-colors hover:bg-surface-gray focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-blue focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--color-bg)]"
        >
          Read insights
        </Link>
      </div>
    </section>
  );
}
